import React, { useState, useEffect } from 'react'
import { getcommunityDetailsbycommId, getcommunityDetailsbycommIdForParentcommunity, UpdatecommunityForUserByData } from '../../AdminActionCreator.component'
import PopUp from "../../../../presentationals/Popup/Popup.component";

export default function DealerAgentEdit({ admin, userdata, editHandler, agentDealerData }) {

    const [stateData, setStateData] = useState([])
    const [dealerData, setdealerData] = useState([])
    const [popup,setPopup] =useState({show:false,popupStatus:''})
    const [obj, setObj] = useState({
        agent: "",
        dealer: "",
    })
    const handleSubmit = () => {
        UpdatecommunityForUserByData(userdata?.userId,String(obj.dealer),admin.emailId,String(obj.agent),callback=>{
            if(callback?.message == "success"){
                // editHandler("")
                setPopup({show:true,popupStatus:'Data Updated Successfully'})
            }else{
                 setPopup({show:true,popupStatus:'Error Updating Data'})
            }
            removePopup()
        })

    }

    useEffect(() => {
        if (agentDealerData || agentDealerData?.agentType) {
            const type = agentDealerData?.agentType == "Amu Agent" ? "Amu Agent" : "Dealer";
            getcommunityDetailsbycommId(type, callback => {
                if (callback?.status == 200) {
                    setStateData(callback?.data)
                } else {
                    setStateData([])
                }
            })
        }

    }, [])


    const handlechange = (e, type) => {
        setObj((prev) => ({
            ...prev,
            [type]: e.target.value
        }))

        if (type == "agent") {
            getcommunityDetailsbycommIdForParentcommunity(e.target.value, callback => {
                if (callback?.status == 200) {
                    setdealerData(callback?.data)
                } else {
                    setdealerData([])
                }
            })
        }
    }

    const closePopup =()=>{
        setPopup({show:false,popupStatus:''})
    }

    const removePopup = ()=>{
        setTimeout(()=>{
closePopup()
        },5000)
    }
    return (
        <>
            <div className="container details-new">
                {
                    popup?.show ? 
                     <PopUp
                        closePopup={closePopup}
                        popupStatus={popup.popupStatus}
                    />
               :"" }

                <div className="details-new background-blur" style={{ background: 'rgb(5 5 5 / 20%)', color: '#000' }}>
                    <div className="edit-box ">
                        <div className="text-right" style={{ color: 'red' }}><i onClick={() => editHandler('')} style={{ fontSize: '20px', cursor: 'pointer' }} className="fa fa-times"></i></div>

                        <h4><b>Edit Agent Details</b></h4>

                        <div className="row" style={{ marginTop: '20px' }}>
                            <div className="col-sm-4 col-xs-12">
                                <label>Select {agentDealerData?.agentType == "Amu Agent" ? "AMU Agent" : "Dealer"}</label>
                                <select className='form-control' value={ agentDealerData?.agentType == "Amu Agent" ? obj.agent : obj.dealer} onChange={(e) => handlechange(e, agentDealerData?.agentType == "Amu Agent" ? "agent" : "dealer")}>
                                    <option value={""}>Select</option>
                                    {
                                        stateData && stateData?.map((val) => {
                                            return (
                                                <option value={val?.communityId}>{val?.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label>Select {agentDealerData?.agentType == "Amu Agent" ? "Dealer" : "AMU Agent" }</label>
                                <select className='form-control' value={agentDealerData?.agentType == "Amu Agent" ? obj.dealer :  obj.agent } onChange={(e) => handlechange(e, agentDealerData?.agentType == "Amu Agent" ?  "dealer" : "agent")}>
                                    <option value={""}>Select</option>
                                    {
                                        dealerData && dealerData?.map((val) => {
                                            return (
                                                <option value={val?.communityId}>{val?.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>


                        </div>

                        <div className="row " style={{ marginTop: '20px' }}>
                            <div className="col-xs-12">
                                <button className="btn btn-primary" id="" onClick={(e) => handleSubmit()}>
                                    Update Personal Details
                                </button>
                            </div>
                        </div>





                    </div>

                </div>
            </div >
        </>
    )
}
